/**
 * This Enum is used for the user preferences sort option preference
 */
export enum OpenProjectSortOption {
  "MOST_RECENT" = "dateLastTouched",
  "TITLE" = "title",
  "START_DATE" = "startDate",
  "END_DATE" = "endDate",
}

/**
 * This class contains utility functionality for the
 * OpenProjectSortOption Enum.
 */
export class ProjectSortOptionUtils {
  /**
   * This function returns the translation string used to display
   * the user readable text for each OpenProjectSortOption
   * @param sortOption should be a property from the OpenProjectSortOption
   */
  static getNameFromProjSortOption(sortOption: string) {
    switch (sortOption) {
      case OpenProjectSortOption.MOST_RECENT:
        return 'PROJECT.OPEN.RECENT';
      case OpenProjectSortOption.TITLE:
        return'PROJECT.OPEN.TITLE' ;
      case OpenProjectSortOption.START_DATE:
        return 'PROJECT.COMMON.START_DATE';
      case OpenProjectSortOption.END_DATE:
        return 'PROJECT.COMMON.END_DATE';
    }
    return '';
  }
}
